window.DEBUG_LOCALSTORAGE_KEY = 'eproc-vsl-debug'

class DebugLogger {

    static init() {
        if (!localStorage.getItem(DEBUG_LOCALSTORAGE_KEY)) {
            localStorage.setItem(DEBUG_LOCALSTORAGE_KEY, 'false');
        }
    }

    /**
     *
     * @param name {string} - prefix of the message
     * @param message {Object} - the message
     */
    static info(name, message = '') {
        DebugLogger.log(name, 'info', message);
    }

    /**
     *
     * @param name {string} - prefix of the message
     * @param level {'info' | 'error'} - log level
     * @param message {Object} - the message
     */
    static log(name, level, message) {
        const isDebug = localStorage.getItem(DEBUG_LOCALSTORAGE_KEY);
        if (isDebug === 'true') {
            if (level === 'info') {
                console.log(`[DEBUG - ${name}]`, message);
            } else if (level === 'error') {
                console.error(name, message);
            }
        }
    }
}

module.exports = DebugLogger;

DebugLogger.init();
